// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Gamification resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient } from '../http.js';

export class GamificationClient {
  constructor(private readonly http: HttpClient) {}

  /** List Gamification State via the Inferrex API. */
  async listGamificationState(options?: { limit?: number | undefined }): Promise<{ state: { player_external_id: string; metric: string; value: number; level: string | null; updated_at: string }[] }> {
    return this.http.get<{ state: { player_external_id: string; metric: string; value: number; level: string | null; updated_at: string }[] }>('/v1/gamification/state', options);
  }
}
